module.exports = __webpack_public_path__ + "media/applicants/device_signup_4-au-f759a90c.jpg";